const trim = v => {
	if (typeof v === 'string') {
		return v.trim();
	}

	return v || '';
}

export const computeUserCompositeId = (userid, name) => {
	if (!userid) {
		return name || '';
	}

	if (!name) {
		return userid || '';
	}

	return `${trim(name)} (${trim(userid)})`;
};

const computeUserDisplayText = (userid, name) => {
	if (name) {
		return trim(name);
	}

	return trim(userid);
};

export const transform = v => {
	const {
		parent_type_key,
		parent_name,
		parent_id,
		customer_name,
		report_created,
		report_id,
		report_type,
		report_updated,
		userid,
		user_name,
		survey_type,
		survey_id,
		survey_external_id,
	} = v; 
	
	const result = {
		parent: {
			id: parent_id,
			name: parent_name,
			typeKey: parent_type_key,
		},
		customer: {
			name: customer_name,
		},
		report: {
			id: report_id,
			type: report_type,
			created: report_created,
			updated: report_updated,
		},
		owner: {
			userid,
			name: user_name,
			compositeId: computeUserCompositeId(userid, user_name),
			displayText: computeUserDisplayText(userid, user_name),
		},
		survey: {
			id: survey_id,
			guid: survey_external_id,
			type: survey_type,
		}
	};

	return result;
};

export default {
	computeUserCompositeId,
	transform
};
